module.exports = __webpack_public_path__ + "./fonts/conthrax-sb.ttf";